"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MULTIPLE_SELECTION_PROPERTY_INPUT_TYPE = void 0;
exports.MULTIPLE_SELECTION_PROPERTY_INPUT_TYPE = {
    checkbox: 'checkbox',
    checkboxHorizontal: 'checkboxHorizontal',
};
